import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from 'vue'
import '@/assets/style/normalize.css'
import '@/assets/style/base.css'
import App from './App.vue'
import router from './router/index'
import pinia from "@/pinia/pinia"
import globalPlugin from '@/plugin/globalPlugin'
import { setGlobalApp } from '@/utils/globalUtils'


const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(globalPlugin)
setGlobalApp(app)
app.mount('#app')
